import SyncOutlined from '@ant-design/icons/lib/icons/SyncOutlined'
import Flex from 'antd/lib/flex'
import Skeleton from 'antd/lib/skeleton'
import MenuIcon from 'Assets/icons/menu.svg'
import MarkdownRenderer from 'Components/common/MarkdownRenderer/MarkdownRenderer'
import { IAttributeGroup } from 'Core/AttributeCore/AttributeGroup/BaseAttributeGroup'
import AIGenerateIcon from 'Assets/icons/generate.svg'

type ModelContentPropsType = {
    modelResponse: string
    isLatestPrompt: boolean
    isLoading: boolean
    onClickRegenerateContent: () => void
    turnLevelAttributes?: IAttributeGroup
    isRegenerationAllowed: boolean
}

export const ModelContent = (props: ModelContentPropsType) => {
    const {
        modelResponse,
        isLatestPrompt,
        isLoading,
        onClickRegenerateContent,
        turnLevelAttributes,
        isRegenerationAllowed,
    } = props

    return (
        <div className="conversation-assistant-turn">
            <img src={AIGenerateIcon} alt="Generate Icon" />
            <div className="conversation-message">
                {isLoading && isLatestPrompt ? (
                    <div className="loading">
                        <div className="content">
                            <img src={MenuIcon} alt={'Thinking'} />
                            <p>Thinking...</p>
                        </div>
                        <Skeleton active={true} />
                    </div>
                ) : (
                    <>
                        <p className="title">Response</p>
                        <p className="response">
                            <MarkdownRenderer children={modelResponse} escapeBackslashses={true} />
                        </p>

                        {turnLevelAttributes?.getElement()?.element}

                        {isRegenerationAllowed && (
                            <Flex
                                className="regenerate-container"
                                gap={5}
                                onClick={onClickRegenerateContent}
                            >
                                <SyncOutlined />
                                <span>REGENERATE</span>
                            </Flex>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}
